import { render, staticRenderFns } from "./actlist.vue?vue&type=template&id=042c081b&scoped=true&"
import script from "./actlist.vue?vue&type=script&lang=js&"
export * from "./actlist.vue?vue&type=script&lang=js&"
import style0 from "./actlist.vue?vue&type=style&index=0&id=042c081b&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c081b",
  null
  
)

export default component.exports